import { resetStoreWithPersistAndSubscribe } from './createStoreWithPersistAndSubscribe';
import { resetStoreWithSubscribe } from './createStoreWithSubscribe';
import { resetStore } from './createStore';
import { resetStoreWithPersist } from './createStoreWithPersist';

export const resetAllStores = () => {
  resetStoreWithSubscribe();
  resetStoreWithPersist();
  resetStoreWithPersistAndSubscribe();
  resetStore();
};
